package com.eladfinish.bible.contest.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDirection
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.background
import com.eladfinish.bible.contest.parchment_verse
import com.eladfinish.bible.contest.pasuk_example
import com.eladfinish.bible.contest.ui.layout.readableWidth
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun ParchmentView(
    modifier: Modifier = Modifier,
    pasukText: AnnotatedString,
    onVerseClick: () -> Unit,
    onVerseLongClick: () -> Unit,
) {
    Box(
        modifier = modifier
            // Wider than this, the scroll image stretches into a thin strip.
            .readableWidth(max = 840.dp)
            .wrapContentHeight()
            .combinedClickable(
                onClick = onVerseClick,
                onLongClick = onVerseLongClick
            ),
        contentAlignment = Alignment.Center
    ) {

        // Background image behind the text
        Image(
            painter = painterResource(SharedRes.images.parchment_verse),
            contentDescription = stringResource(SharedRes.strings.background),
            contentScale = ContentScale.FillBounds,
            modifier = Modifier
                .matchParentSize() // equivalent to fill constraints in ConstraintLayout
        )

        // Text centered with padding
        Text(
            text = pasukText,
            textAlign = TextAlign.Center,
            modifier = Modifier
                .padding(start = 36.dp, end = 42.dp, top = 16.dp, bottom = 24.dp),
            fontSize = 21.sp,
            color = Color.Black,
            style = MaterialTheme.typography.bodyLarge.copy(
                textDirection = TextDirection.Content,
                fontSize = 16.sp,
                color = Color.Black,
                lineHeight = 28.sp,
            )
        )
    }
}

@Preview
@Composable
private fun ParchmentViewPreview() {
    val pasukText = stringResource(SharedRes.strings.pasuk_example)
    ParchmentView(
        pasukText = AnnotatedString(text = pasukText),
        onVerseClick = {},
        onVerseLongClick = {},
    )
}
